import { Culture, cultureLabels, cultures, VolunteersHighlightRules } from "../../context/VolunteersHighlightContext/constants";
import { Dimension } from "../FileUploadComponent/constants";

export const GENERAL_SECTION_KEY = "general";

export const getDetailSectionKey = (culture: Culture) => `detail-${culture}`;

export const VolunteersHighlightFormKeys = [GENERAL_SECTION_KEY, ...cultures.map(getDetailSectionKey)];

export const VolunteersHighlightSectionLabels = {
	GENERAL: "Genel Özellikler",
	getDetail: (culture: Culture) => `Öne Çıkan Detayı - ${cultureLabels[culture]}`,
};

export const VolunteersHighlightGeneralTexts = {
	isActive: {
		label: "Aktiflik Durumu",
		helperText: "Aktif olmayan öne çıkanlar sayfada gözükmez.",
	},
	displayOrder: {
		label: "Sıra Numarası",
		placeholder: "1",
	},
};

type DetailFieldTexts = {
	title: { label: string; placeholder: string };
	description: { label: string; placeholder: string };
	image: { label: string };
};

export const VolunteersHighlightDetailTexts: Record<Culture, DetailFieldTexts> = {
	"tr-TR": {
		title: {
			label: "Başlık",
			placeholder: "Geleceğin Suyu",
		},
		description: {
			label: "Açıklama",
			placeholder: "Temiz suya erişimi desteklemek için gönüllülerimizle farkındalık çalışmaları yürütüyoruz.",
		},
		image: {
			label: "Öne Çıkan Resmi",
		},
	},
	"en-US": {
		title: {
			label: "Title",
			placeholder: "Water of the Future",
		},
		description: {
			label: "Description",
			placeholder: "We run awareness activities with our volunteers to support access to clean water.",
		},
		image: {
			label: "Highlight Image",
		},
	},
};

export const VolunteersHighlightImageUpload: {
	maxFileSize: string;
	extensions: ("jpeg" | "jpg" | "png")[];
	dimensions: Dimension[];
} = {
	maxFileSize: String(VolunteersHighlightRules.imageMaxFileSize),
	extensions: ["jpeg", "jpg", "png"],
	dimensions: [VolunteersHighlightRules.imageDimension],
};
